// Services/fetchWeeklySalesReport.js
import { REPORTS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

// Reemplaza {restauranteId} en el template
const pathWithParams = (template, params) =>
  template.replace(/\{(\w+)\}/g, (_, key) => encodeURIComponent(params[key] ?? ""));

// date (opcional): "YYYY-MM-DD" — cualquier día dentro de la semana que se quiere consultar
export const fetchWeeklySalesReport = async (restauranteId, date) => {
  if (!restauranteId) {
    return { statusCode: 400, message: "restauranteId es requerido" };
  }

  const path = pathWithParams(REPORTS.weeklySales, { restauranteId });
  const query = date ? `?date=${encodeURIComponent(date)}` : "";

  const res = await ApiRequestInterceptor(`${path}${query}`, "GET", null);

  if (res?.code === 200) {
    return { statusCode: 200, ...res.data };
  }
  if (res?.code === 401) return { statusCode: 401, message: res?.data?.message || "Token inválido o expirado" };
  if (res?.code === 403) return { statusCode: 403, message: res?.data?.message || "No autorizado" };

  return {
    statusCode: res?.code || 500,
    message: res?.data?.message || "Error al obtener el reporte semanal",
  };
};
